import { useState } from 'react';
import { Loader2, Paperclip } from 'lucide-react';
import { cn } from '../../../../foundation/altzero_base/base/lib/utils';
import { attachmentService } from '../../services/attachmentService';

/** Opens the bill's invoice in a new tab (job 90): checking a row against its
 *  invoice should not mean leaving the board. Used by Bulk Bill Run and Bill Runs. */
export function InvoiceLink({ path, testId = 'bill-runs-open-invoice' }: { path?: string | null; testId?: string }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!path) return null;
  const open = async () => {
    // Opened inside the click, before the await: a popup blocker (Safari,
    // strict Firefox) blocks a window.open that comes after it.
    const tab = window.open('', '_blank');
    setBusy(true);
    setFailed(false);
    const url = await attachmentService.getSignedUrl(path);
    setBusy(false);
    if (url && tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      tab?.close();
      setFailed(true);
    }
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => void open()}
      disabled={busy}
      title={failed ? 'Could not open the invoice — try again' : 'Open invoice in a new tab'}
      className={cn(
        'inline-flex items-center gap-0.5 text-xs hover:underline disabled:opacity-50',
        failed ? 'text-red-600' : 'text-blue-600',
      )}
    >
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Paperclip className="h-3 w-3" />}
      Invoice
    </button>
  );
}
